import React, { memo, useEffect, useState } from 'react';
import TruncatedTextSystem from '../../../../../DesignSystem/TruncatedTextSystem';

const Surname = memo(({ surname, width, onBlur, isValidRole }) => {
  const [value, setValue] = useState(surname);

  useEffect(() => {
    setValue(surname || '');
  }, [surname]);

  const handleChange = ({ target }) => {
    const { value } = target;
    setValue(value);
  };

  const handleBlur = () => {
    onBlur(value);
  };

  if (!isValidRole)
    return (
      <TruncatedTextSystem
        name={surname}
        maxWidth={width > 1600 ? 130 : 80}
        placement={'topLeft'}>
        <span className="surname-column">{surname}</span>
      </TruncatedTextSystem>
    );

  return (
    <input
      type="text"
      name="surname"
      className="surname-column-input"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      autoComplete="off"
    />
  );
});

export default Surname;
